import { queryOptions } from '@tanstack/react-query';
import { playerAPI } from '../services/api';
import { playerKeys } from './keys';
import type { PlayerData } from '../types/serverData';

export const emptyPlayerData: PlayerData = {
  player: {},
  prices: {},
  scores: {},
};

export const fetchPlayerDetail = async (
  slug: string,
  signal?: AbortSignal,
): Promise<PlayerData> => {
  if (!slug) {
    return emptyPlayerData;
  }
  const data = await playerAPI.getPlayer(slug, { signal });
  return data ?? emptyPlayerData;
};

export const playerDetailQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: playerKeys.detail(slug),
    queryFn: ({ signal }) => fetchPlayerDetail(slug, signal),
  });
